import React, { Component } from "react";
import PropTypes from "prop-types";
import Form from "react-bootstrap/lib/Form";
import Col from "react-bootstrap/lib/Col";
import { ConsultationCategory } from "./ConsultationCategory";

export class ConsultationCategoryContainer extends Component {
  render() {
    return (
      <React.Fragment>
        <Form.Row>
          <Col>
            {this.props.items.map((item, index) => {
              let errors =
                this.props.errors &&
                this.props.errors.categories &&
                this.props.errors.categories.length > 0
                  ? this.props.errors.categories[index]
                  : undefined;
              return (
                <div key={`${this.props.prefixName}categories.${index}.`}>
                  <ConsultationCategory
                    {...item}
                    categoryIndex={index}
                    consultationFormType={this.props.consultationFormType}
                    disabled={this.props.disabled}
                    isResultPublished={this.props.isResultPublished}
                    loggedUserId={this.props.loggedUserId}
                    formIndex={this.props.formIndex}
                    prefixName={`${this.props.prefixName}categories.${index}.`}
                    projectType={this.props.projectType}
                    rowId={index + 1}
                    isAuth={this.props.isAuth}
                    availableVoteNotLogged={this.props.availableVoteNotLogged}
                    onChange={this.props.onChange}
                    onBlur={this.props.onBlur}
                    setFieldValue={this.props.setFieldValue}
                    errors={errors}
                    isPreview={this.props.isPreview}
                  />
                </div>
              );
            })}
          </Col>
        </Form.Row>
      </React.Fragment>
    );
  }
}

ConsultationCategoryContainer.propTypes = {
  consultationFormType: PropTypes.number,
  disabled: PropTypes.bool,
  formIndex: PropTypes.number,
  isResultPublished: PropTypes.bool,
  loggedUserId: PropTypes.number,
  projectType: PropTypes.number,

  errors: PropTypes.object,

  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      maxPoint: PropTypes.number,
      title: PropTypes.string,
      questions: PropTypes.arrayOf(
        PropTypes.shape({
          canComment: PropTypes.bool,
          content: PropTypes.string,
          id: PropTypes.number,
          maxPoint: PropTypes.number,
          order: PropTypes.number,
          questionOptionCount: PropTypes.number,
          questionResultQuantitySum: PropTypes.number,
          questionType: PropTypes.number,
          answers: PropTypes.arrayOf(
            PropTypes.shape({
              categoryId: PropTypes.number,
              id: PropTypes.number,
              questionId: PropTypes.number,
              userId: PropTypes.number,
              answerOptions: PropTypes.arrayOf(
                PropTypes.shape({
                  comment: PropTypes.string,
                  id: PropTypes.number,
                  openDate: PropTypes.string,
                  openText: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                  ]),
                  questionMatrixValueId: PropTypes.number,
                  questionOptionId: PropTypes.number,
                  ranking: PropTypes.number,
                })
              ),
            })
          ),
          questionMatrixValues: PropTypes.arrayOf(
            PropTypes.shape({
              content: PropTypes.string,
              id: PropTypes.number,
              order: PropTypes.number,
            })
          ),
          questionOptions: PropTypes.arrayOf(
            PropTypes.shape({
              content: PropTypes.string,
              id: PropTypes.number,
              order: PropTypes.number,
            })
          ),
          questionResults: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number,
              quantity: PropTypes.number,
              questionOptionName: PropTypes.string,
            })
          ),
        })
      ),
    })
  ),

  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  setFieldTouched: PropTypes.func,
  setFieldValue: PropTypes.func,
};

ConsultationCategoryContainer.defaultProps = {
  consultationFormType: 0,
  disabled: false,
  formIndex: 0,
  isResultPublished: false,
  loggedUserId: 0,
  projectType: 0,

  errors: {},

  items: [],

  onBlur: Function.prototype,
  onChange: Function.prototype,
  setFieldTouched: Function.prototype,
  setFieldValue: Function.prototype,
};
